import React, { Component } from 'react';

/** UI Kit */
import { TxtDefault } from '@atresmedia/intranet-texts';

/** Core */
import Label from '../../../core/Label';
import Input from '../../../core/Input';
import Icon from '../../../core/Icon';
import Loading from '../../../core/Loading';

import Error from '../../Error';

/** Styles */
import {
  StyledPreviousPayrolls,
  StyledTitle,
  StyledPayrrollMsj,
  StyledButtonsWrapper,
  StyledButtonSecondary
} from './style';

import { Ok, Exclamation } from '../../../../../assets/images/index';

import { postPayrollIncidence } from '../../../../utils/apiPayroll';

class PayrrollIncidence extends Component {
  constructor(props) {
    super(props);

    this.state = {
      matter: '',
      incidence: '',
      error: {
        state: false,
        code: null,
        msg: null
      },
      sent: false, // true: E-mail sent
      loading: false, // waiting response
      success: false // true: success, false: error
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.formPayrroll !== state.formPayrroll) {
      return { sent: false };
    }
    return null;
  }

  senEmail = () => {
    const { matter, incidence } = this.state;
    this.setState({ loading: true });
    postPayrollIncidence(matter, incidence)
      .then(() => {
        this.setState({
          sent: true,
          loading: false,
          success: true,
          matter: '',
          incidence: ''
        });
        document.getElementById('form-employee-attention').reset();
      })
      .catch(e => {
        this.setState({ error: { state: true, code: e.code, msg: e.message } });
      });
  };

  render() {
    const { sent, success, loading, error, matter, incidence } = this.state;
    const { formPayrroll, onClickOpenIncidence } = this.props;
    const disabled = !!(matter.length === 0 || incidence.length === 0);
    return (
      <React.Fragment>
        {error.state ? (
          <Error code={error.code} message={error.msg} />
        ) : (
          <StyledPreviousPayrolls>
            <StyledTitle>
              {formPayrroll
                ? `Formulario atención empleado`
                : `Buzón de atención al empleado`}
            </StyledTitle>
            {!formPayrroll && (
              <p className="mb-30">
                ¿Tienes alguna duda respecto a tu nómina o contrato?.
              </p>
            )}
            {formPayrroll && (
              <form id="form-employee-attention">
                <Label label="Asunto *" htmlFor="asunto" className="mb-5" />
                <Input
                  id="asunto"
                  name="asunto"
                  className="mb-10"
                  required
                  onChange={e => this.setState({ matter: e })}
                />
                <Label label="Detalle *" htmlFor="desc" className="mb-5" />
                <Input
                  multiline
                  required
                  id="desc"
                  name="desc"
                  className="mb-15"
                  onChange={e => this.setState({ incidence: e })}
                />

                <StyledPayrrollMsj sent={sent} loading={loading}>
                  {sent && !loading && (
                    <TxtDefault
                      className={
                        success === true ? `form-success` : `form-error`
                      }
                    >
                      <Icon
                        size="m"
                        svg={success === true ? Ok : Exclamation}
                        color={success === true ? `success` : `error`}
                        className="mr-10 pt-10"
                      />
                      {success === true
                        ? `Tu consulta se envió correctamente`
                        : `Error: No se pudo enviar la consulta.`}
                    </TxtDefault>
                  )}
                </StyledPayrrollMsj>
                {loading && (
                  <Loading className="payrroll-loading" txt="Enviando email" />
                )}
              </form>
            )}
            <StyledButtonsWrapper formPayrroll={formPayrroll}>
              {/* <StyledButtonGhost ghost>VER</StyledButtonGhost> */}
              {formPayrroll ? (
                <StyledButtonSecondary
                  disabled={disabled}
                  secondary
                  className="fr"
                  onClick={e => this.senEmail(e)}
                  type="submit"
                >
                  Enviar consulta
                </StyledButtonSecondary>
              ) : (
                <StyledButtonSecondary
                  secondary
                  className="fr"
                  onClick={onClickOpenIncidence}
                >
                  Envía tu consulta
                </StyledButtonSecondary>
              )}
            </StyledButtonsWrapper>
          </StyledPreviousPayrolls>
        )}
      </React.Fragment>
    );
  }
}

export default PayrrollIncidence;
